export function copyQuestion(question) {
	localStorage.setItem('copiedQuestion', JSON.stringify(question))
	return null
} 

 


